import React from 'react'

class Page extends React.Component {
  render() {
    return this.props.children
  }
}

export default Page
